import List from 'containers/Subscriptions/List';
import ResultSignUp from 'containers/Subscriptions/ResultSignUp';

export default { List, ResultSignUp };
